import { Component, OnInit } from '@angular/core'
import { environment } from '../../../environments/environment'
import { FaqService } from './services/faq.service'

import {
  User,
  AuthService,
  GlobalMessageService,
  GlobalMessageType,
} from '@spartacus/core'

@Component({
  selector: 'app-faq-page',
  standalone: false,
  templateUrl: './faq-page.component.html',
  styleUrl: './faq-page.component.scss',
})
export class FaqPageComponent implements OnInit {
  public faqSearchText: string = ''
  baseUrl: string = environment.occBaseUrl
  faqItems: any = []
  openStates: { [key: number]: boolean } = {}
  filteredItems: any[] = []

  constructor(
    private faqService: FaqService,
    private globalMessageService: GlobalMessageService
  ) {}

  getFAQData() {
    this.faqService.getFAQ().subscribe(
      (data) => {
        this.faqItems = data
        this.faqItems.map((item, index) => {
          item._id = index
          item.answer = item.answer.replace(/\\n/g, '\n')
          if (item.faqImage) {
            item.faqImage.url = item.faqImage.url
              ? this.baseUrl + item.faqImage.url
              : ''
            item.isOpen = false
          }
        })

        this.updateFilteredItems()
      },
      (error) => {
        this.globalMessageService.add(
          error,
          GlobalMessageType.MSG_TYPE_ERROR,
          5000
        )
        window.scrollTo(0, 0)
      }
    )
  }

  ngOnInit(): void {
    this.getFAQData()
  }

  toggleFaq(item: any): void {
    this.openStates[item._id] = !this.openStates[item._id]
    item.isOpen = !item.isOpen
  }

  updateFilteredItems(): void {
    if (!this.faqSearchText.trim()) {
      this.filteredItems = this.faqItems.map((item, idx) => ({
        ...item,
        isOpen: false,
      }))
    } else {
      const q = this.faqSearchText.toLowerCase()
      this.filteredItems = this.faqItems
        .filter(
          (item) =>
            item.question?.toLowerCase().includes(q) ||
            item.answer?.toLowerCase().includes(q)
        )
        .map((item, idx) => ({
          ...item,
          isOpen: !item.isOpen,
        }))
    }
  }
}
